type BtnGroupItem = {
    label: string | number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic button value (enums, numbers, strings, …) set back into dynamic config
    value: any;
    icon?: string;
}

type Props = {
    className?: string;
    items: BtnGroupItem[];
    isActive: (value: BtnGroupItem["value"]) => boolean;
    set: (value: BtnGroupItem["value"]) => void;
}

export default function UiBtnGroup(props: Props) {
    return (
        <div className={`${props.className || "btn-group"} bg-white`} role="group">
            {props.items.map((item, i) => (
                <button
                    key={i}
                    type="button"
                    className={`btn ${props.isActive(item.value) ? "btn-primary" : "btn-outline-secondary"}`}
                    title={item.label.toString()}
                    onClick={() => props.set(item.value)}
                >
                    {item.icon ? (
                        <>
                            <span className={`bi-${item.icon}`}></span>
                            <span className="ms-1">{item.label}</span>
                        </>
                    ) : item.label}
                </button>
            ))}
        </div>
    );
}
